

















































































import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import AdminDeviceTypeService from '../../services/admin.devicetype.service';
import AddManufacturer from '@/components/devicetypes/AddManufacturer.vue';
import AddDeviceModel from '@/components/devicetypes/AddDeviceModel.vue';
import AddChipManufacturer from '@/components/devicetypes/AddChipManufacturer.vue';
import FileUpload from '@/components/FileUpload.vue';
import { Route } from 'vue-router';
import { Cropper } from 'vue-advanced-cropper';
import '../../classes/blob.image.convert';
import Dialog from '@/components/Dialog.vue';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import AdminGatewayTypeService from '@/services/admin.gatewaytype.service';

@Component({
  components: {
    ConfirmButton,
    CancelButton,
    Dialog,
    AddManufacturer,
    AddDeviceModel,
    AddChipManufacturer,
    FileUpload,
    Cropper,
  },
})
export default class AdminGatewayTypeSettings extends Vue {
  private menuItems: any[] = [
    { id: 0, title: 'Details', path: 'gatewayTypeDetails'},
  ];
  private gatewayType: any = null;
  private clicked: any = {};
  private snackbar: boolean = false;

  private logo: Blob | null = null;

  @Watch('$route.path', {immediate: true})
  private onRouteChange() {
    this.getSelected();
  }

  private getSelected() {
    this.clicked = this.menuItems[0];
  }

  private async mounted() {
    this.getSelected();

    await this.initGatewayType();
  }

  private async initGatewayType() {
    if (this.$route.params.id === 'new') {
      this.gatewayType = {
        name: '',
        slug: '',
        keepAlive: 0,
        has_cellular_backhaul: false,
      };
    } else {
      this.gatewayType = await AdminGatewayTypeService.getSystemGatewayType(Number(this.$route.params.id));
    }
  }

  private async saveGatewayType(gatewayType: any, logoData: any = {}) {
    gatewayType.keepAlive = gatewayType.keep_alive ? gatewayType.keep_alive : null;
    if (this.$route.params.id !== 'new') {
      this.gatewayType.id = this.$route.params.id;
    }
    if (!gatewayType.name) {
      throw new Error('Please set a name');
    }
    let resp = null;
    let gatewayTypeId: number;
    if (this.gatewayType.id) {
      resp = await AdminGatewayTypeService.updateSystemGatewayType(this.gatewayType.id, gatewayType);
    } else {
      resp = await AdminGatewayTypeService.addSystemGatewayType(gatewayType);
    }
    if (!resp.id) {
      return;
    }
    this.snackbar = true;

    gatewayTypeId = resp.id;

    if (logoData.saveImage) {
      if (logoData.croppedLogo || logoData.logo) {
        await AdminGatewayTypeService.uploadGatewayLogo(gatewayTypeId, logoData.croppedLogo || (await logoData.logo!.toPNG()));
        if (logoData.croppedLogo) {
          logoData.showCropper = false;
          this.logo = logoData.croppedLogo;
          // this.$forceUpdate();
        }
      } else {
        await AdminGatewayTypeService.removeGatewayLogo(gatewayTypeId);
      }
    }
    if (this.gatewayType.id) {
      await this.initGatewayType();
    } else if (this.$route.params.id === 'new') {
      this.$router.push({name: 'gatewayTypeDetails', params: {id: gatewayTypeId.toString()}});
    }
  }

  private async beforeRouteUpdate(to: Route, from: Route, next: any) {
    this.gatewayType.id = to.params.id;
    await this.initGatewayType();
    next();
  }
}
